export const testimonialTranslations = {
  TESTIMONIAL_HEADER: 'Wat onze klanten zeggen over Tranzer'
}
